;(function() {

"use strict"
window.vue.component.EventBus = {}
window.vue.component.EventBus.main = function() {
  window.vue.EventBus = new Vue()
}

})();